<div class="deployment-stepper-container text-gray">
  <div class="modal-header">
    <div [style.background]="'url(' + image + ')'" class="iconImage"></div>
    <h4 class="modal-title synchpc-primary ms-2" id="modal-title">{{ cloudName }} - Create Deployment</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger text-danger" color="warn" (click)="onCancel()" title="Close"></i>
  </div>

  <div class="container">
    <nav class="tabs">
      <a 
        *ngFor="let tab of tabs; let i = index" 
        [class.active]="activeTabIndex === i"
        [class.disabled]="tab.disabled"
        (click)="setActiveTab(i)"
      >
        {{tab.label}}
      </a>
    </nav>
  
      <form [formGroup]="deploymentForm" (ngSubmit)="onSubmit()">
        <div class="content" [ngSwitch]="activeTabIndex" style="height: 45vh;">
          <!-- Basics Tab -->
          <div *ngSwitchCase="0" formGroupName="deployment" style="max-height: 45vh; overflow: auto;">
            <div class="form-group">
                <label>
                  Deployment Name *
                  <!-- Tooltip Icon -->
                  <span class="bi bi-info-circle-fill synchpc-primary infoIconConfig"
                      placement="top-right" container="body"
                      style="margin-right: 0.3 rem;"
                      triggers="hover" [ngbTooltip]="syncHpcTooltips"></span>
                    <ng-template #syncHpcTooltips>
                      <p>Enter deployment name which uniquely identifies your HPC cluster. It can contain only small case letters and numbers. It must start with a letter. Deployment name should be more than 2 and less than 12 characters.</p>
                    </ng-template>
                  <input type="text" formControlName="deploymentName">
                </label>
                <div class="error" *ngIf="deploymentForm.get('deployment.deploymentName')?.touched && deploymentForm.get('deployment.deploymentName')?.errors?.['required']">
                  Deployment name is required!
                </div>
                <div class="error" *ngIf="deploymentForm.get('deployment.deploymentName')?.touched && deploymentForm.get('deployment.deploymentName')?.errors?.['pattern']">
                  Please enter valid deployment name!
                </div>
              </div>

            <div class="form-group">
                <label>
                  Location *
                  <!-- Tooltip Icon -->
                  <span class="bi bi-info-circle-fill synchpc-primary infoIconConfig"
                      placement="top-right" container="body"
                      style="margin-right: 0.3 rem;"
                      triggers="hover" [ngbTooltip]="syncHpcTooltipsLoc"></span>
                    <ng-template #syncHpcTooltipsLoc>
                      <p>Enter the location/region, where the cluster is being deployed. E.g. California-USA.</p>
                    </ng-template>
                  <input type="text" formControlName="Location">
                </label>
                <div class="error" *ngIf="deploymentForm.get('deployment.Location')?.touched && deploymentForm.get('deployment.Location')?.errors?.['required']">
                  Please enter location!
            </div>
              </div>

            <div class="form-group">
                <label>
                  Credentials *
                  <span class="bi bi-info-circle-fill synchpc-primary infoIconConfig"
                  placement="top-right" container="body"
                  style="margin-right: 0.3 rem;"
                  triggers="hover" [ngbTooltip]="syncHpcTooltipscred"></span>
                <ng-template #syncHpcTooltipscred>
                  <p>Create credentials for deployment.</p>
                </ng-template>
                  <select style="padding: 4px" formControlName="credentials">
                    <option *ngFor="let cred of credentials" [value]="cred">{{ cred }}</option>
                  </select>
                </label>
                <a class="create-new" (click)="createNewCreds()">Create new credential</a>
                <div class="error" *ngIf="deploymentForm.get('deployment.credentials')?.errors?.['required'] && deploymentForm.get('deployment.credentials')?.touched">
                  Credentials is required
            </div>
            </div>

            <div class="form-group">
              <label class="form-label">Do you want to add existing virtual machine(VMs) available on kvm?</label>
              <div class="d-flex align-items-center gap-3  m-2">
                <div class="form-check form-check-inline">
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    id="syncKvm"
                    formControlName="syncKvm" 
                    [value]="true"
                    (change)="onSyncChange(true)"
                  >
                  <label class="form-check-label" for="syncKvm">
                    Yes
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    id="syncKvmNo"
                    formControlName="syncKvm" 
                    [value]="false"
                    (change)="onSyncChange(false)"
                  >
                  <label class="form-check-label" for="syncKvmNo">
                    I will do it later
                  </label>
                </div>
              </div>

            </div>

            </div>

          <!-- Node Tab -->
          <div *ngSwitchCase="1" formGroupName="node">
            <div>
              <h4 class="h4local">Available Virtual Machines</h4>
              <form style="margin-bottom: 10px;">
                <div class="actionBar d-flex" style="height: 1.6rem">
                  <div class="flex-grow-1">
                    <input 
                      class="searchBar float-start" 
                      type="text" 
                      name="searchInput"
                      [(ngModel)]="filterText"
                      (ngModelChange)="applyFilter()"
                      placeholder="Search by name"
                    />
                  </div>
                </div>
              </form>

              <div class="table-responsive" style="max-height: 40vh; overflow-y: auto;">
                <table class="table table-hover text-gray" cellspacing="0" style="border-collapse: collapse">
                  <thead class="sticky-top bg-light" style="border-bottom: 2px solid gray;">
                    <tr style="height: 22px" class="table-list-head">
                      <th style="width:70px; text-align: center;" class="selectAllCheckBox" title="Select All" (change)="onSelectAllCheckBox($event)">
                        <input type="checkbox" [checked]="isSelectAll" id="">
                      </th>
                      <th scope="col" style="padding: 6px">
                        <a style="text-decoration: none; cursor: default">Name</a>
                      </th>
                      <th scope="col" style="padding: 6px">
                        <a style="text-decoration: none; cursor: default">IP</a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let node of applyFilter(); let i = index" class="table-list-row">
                      <td style="text-align: center;">
                        <input type="checkbox" title="Select Node" class="selectCheckbox" (click)="checkSelectedCheckboxes($event, node.vmNames)" [checked]="multiSelectIndex.includes(node.vmNames)">
                      </td>
                      <td>{{ node.vmNames }}</td>
                      <td>{{ node.ip }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Review Tab -->
          <div *ngSwitchCase="2" style="max-height: 45vh; overflow: auto;">
            <div class="review-section">
              <h3 style="font-size: 13px;">Deployment</h3>
              <div class="review-item">
                <span class="label">Deployment Name : </span>
                <span class="value">{{deploymentForm.get('deployment.deploymentName')?.value}}</span>
              </div>
              <div class="review-item">
                <span class="label">Location : </span>
                <span class="value">{{deploymentForm.get('deployment.Location')?.value}}</span>
              </div>
              <div class="review-item">
                <span class="label">Credentials : </span>
                <span class="value">{{deploymentForm.get('deployment.credentials')?.value}}</span>
              </div>
            </div>

            <!-- Show Selected VMs in Review Tab -->
            <div class="review-section" *ngIf="syncKvm && selectedVMs.length > 0">
              <h3 style="font-size: 13px">Selected VMs/Nodes To Sync : </h3>
              <div class="overflow-auto">
                <table class="table table-hover">
                  <thead>
                    <tr style="background-color: grey;">
                      <th scope="col">Name</th>
                      <th scope="col">IP</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let vm of selectedVMs">
                      <td>{{vm.vmNames}}</td>
                      <td>{{vm.ip}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
  
        <div class="navigation modal-footer">
          <button 
            type="button"
            class="previous" 
            [disabled]="activeTabIndex === 0"
            (click)="navigateToPreviousTab()"
          >
            Previous
          </button>
          <button 
            type="button"
            class="next" 
            *ngIf="activeTabIndex < tabs.length - 2 && tabs[activeTabIndex + 1].disabled == false"
            (click)="navigateToNextTab()"
          >
            Next: {{tabs[activeTabIndex + 1].label}}
          </button>
          <button *ngIf="activeTabIndex == 2" type="submit" class="review" [disabled]="!deploymentForm.valid">Create</button>
          <button 
            *ngIf="activeTabIndex != 2"
            type="button"
            class="review" 
            (click)="setActiveTab(tabs.length - 1)"
          >
            Review + create
          </button>
        </div>
      </form>
  </div>
  <ngx-spinner
        bdColor="rgba(236,236,236,0.8)"
        size="default" zIndex = "1"
        color="var(--s-primary-color)"
        type="ball-spin"
        [fullScreen]="false"
        name="addDeployment">
      </ngx-spinner>
</div>
